import React, { useEffect, useState } from "react";
import { Badge, Card, Form, Label, Spinner } from "reactstrap";
import { BiEdit, BiMinus, BiPlus } from "react-icons/bi";
import { useForm } from "react-hook-form";
import { addHomeBannerAPI, getBannerEditAPI, getHomeBannerListAPI, statusUpdateBannerAPI } from "../../api/banner";
import Select from "react-select";
import { toast } from "react-toastify";
import { decrypt, decryptFormData, encrypt, encryptFormData } from "../../utils/Encrypt";
import ViewImage from "../../myComponents/modals/ViewImage";
import MyDataTable from "../../myComponents/DataTable/MyDataTable";
import ConfirmModal from "../../myComponents/modals/ConfirmModal";
import Required from "../../myComponents/validate/Required";
import ImageUpload from "../../myComponents/form/ImageUpload";
import Head from "../../layout/head/Head";
import useLogout, { ValidateImgWithSize } from "../../utils/Utils";
import Content from "../../layout/content/Content";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  PreviewAltCard,
  Row,
} from "../../components/Component";
const Banner = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [mode, setMode] = useState("Add");
  const [data, setData] = useState([]);
  const userData = JSON.parse(localStorage.getItem("userDetail"));
  const IMAGE_BASE_URL = localStorage.getItem("IMAGE_BASE_URL");
  const [column, setColumn] = useState([
    {
      name: "Order",
      selector: (row) => row?.order,
      sortable: true,
    },
    {
      name: "Image Alt",
      selector: (row) => row?.image_alt,
      sortable: true,
    },
    {
      name: "Image Alt Hindi",
      selector: (row) => row?.hn_image_alt,
      sortable: true,
    },
    {
      name: "Image",
      selector: (row) => (
        <div onClick={() => handleImageOpenPreview(`${IMAGE_BASE_URL}` + row?.banner_image)}>
          <img style={{ width: "50px" }} src={`${IMAGE_BASE_URL}` + row.banner_image} />
        </div>
      ),
      sortable: true,
    },
    {
      name: "Image Hindi",
      selector: (row) => (
        <div onClick={() => handleImageOpenPreviewHindi(`${IMAGE_BASE_URL}` + row?.banner_image_hn)}>
          <img style={{ width: "50px" }} src={`${IMAGE_BASE_URL}` + row.banner_image_hn} />
        </div>
      ),
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) => row?.status,
      cell: (row) => (
        <div style={{ cursor: "pointer" }} onClick={() => handleToggleStatus(row)}>
          <Badge color={`${row.status ? "success" : "danger"}`}>{row.status ? "Active" : "InActive"}</Badge>
        </div>
      ),
      sortable: true,
      wrap: true,
    },
    {
      name: "Action",
      wrap: true,
      cell: (row) => (
        <div>
          <Button outline color={`warning`} size={`xs`} className={`me-1`} onClick={() => handleEdit(row)}>
            {" "}
            <Icon name="edit" />
          </Button>
          {/* <Button outline color={`danger`} size={`xs`} onClick={() => handleDelete(row)}>
              {" "}
              <Icon name="trash"></Icon>
            </Button> */}
        </div>
      ),
    },
  ]);
  const logout = useLogout();
  const handleToggleStatus = (row) => {
    setSelectedRow(row);
    setShowModal(true);
  };

  // Modal Image Preview
  const [imageOpen, setImageOpen] = useState(false);
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    setError,
    clearErrors,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      banner_image_url: null,
      banner_image_url_hn: null,

      emails: [{ value: "" }], // Ensures one default email field
      phones: [{ value: "" }], // Ensures one default phone field
    },
  });

  useEffect(() => {
    getBannerData();
  }, []);
  const getBannerData = () => {
    const data = {};
    getHomeBannerListAPI(data)
      .then((res) => {
        // decrypt data
        const status = decrypt(res.data.status);
        if (status === "success") {
          const decryptedResponse = decrypt(res.data.data.tableData);
          toast.success(res.data.message);
          setData(decryptedResponse);
          toast.clearWaitingQueue();
        } else if (status === "failed") {
          toast.warning(res.data.message);
          toast.clearWaitingQueue();
          setData([]);
        } else if (status === "expired") {
          toast.error(res.data.message);
          logout();
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const handleEdit = (row) => {
    window.scrollTo(0, 0);
    setIsOpen(!isOpen);
    setMode("Edit");
    setValue("id", row.id); // Add this for consistent `formData` structure
    setValue("image_alt", row.image_alt);
    setValue("image_alt_hn", row.hn_image_alt);
    setValue("order", row.order);
    setValue("image-menu", row.banner_image);
    setValue("image-menu", row.banner_image_hn);

    const imageUrl = `${IMAGE_BASE_URL}${row.banner_image}`;
    setValue("banner_image_url", imageUrl);
    const imageUrl_hn = `${IMAGE_BASE_URL}${row.banner_image_hn}`;

    setValue("banner_image_url_hn", imageUrl_hn);

    setValue("banner_image", row.banner_image);
    setValue("banner_image_hn", row.banner_image_hn);

    setValue("status", {
      label: row.status ? "Active" : "InActive",
      value: row.status,
    });
  };

  const onFormSubmit = async (data) => {
    const formData = new FormData();
    formData.append("image_alt", data.image_alt);
    formData.append("hn_image_alt", data.image_alt_hn);
    formData.append("order", data.order);
    formData.append("status", data.status.value);
    formData.append("module", "home_banner");
    const newFd = new FormData();
    if (mode == "Edit") {
      formData.append("id", watch("id"));
    }
    const encryptedData = await encryptFormData(formData);
    newFd.append("zero", encryptedData);
    if (watch("banner_image_url") == null) {
      newFd.append("banner_image", data?.banner_image[0]);
      newFd.append("banner_image_hn", data?.banner_image_hn[0]);
    } else {
      newFd.append("banner_image", data?.banner_image);
      newFd.append("banner_image_hn", data?.banner_image_hn);
    }
    if (mode === "Add") {
      addHomeBannerAPI(newFd)
        .then((res) => {
          const status = decrypt(res.data.status);
          if (status == "success") {
            toast.success(res.data.message);
            toast.clearWaitingQueue();
            getBannerData();
            setIsOpen(false);
            setIsLoading(false);
          } else if (status === "failed") {
            setIsLoading(false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
          } else if (status === "expired") {
            setIsLoading(false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
            logout();
          }
        })
        .catch((err) => {
          setIsLoading(false);
          toast.error(err.message);
        });
    }
    if (mode === "Edit") {
      getBannerEditAPI(newFd)
        .then((res) => {
          const status = decrypt(res.data.status);
          if (status == "success") {
            toast.success(res.data.message);
            getBannerData();
            setIsOpen(false);
            setIsLoading(false);
          } else if (status === "failed") {
            setIsLoading(false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
          } else if (status === "expired") {
            setIsLoading(false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
            logout();
          }
        })
        .catch((err) => {
          setIsLoading(false);
          toast.error(err.message);
        });
    }
  };
  const handleImageChange = (e, errorInput, url) => {
    const file = e.target.files[0];
    if (file) {
      ValidateImgWithSize(file, (isValid, message) => {
        if (isValid) {
          setValue(errorInput, file); // Set as File object, not string
          const imageUrl = URL.createObjectURL(file);
          setValue(url, imageUrl);
          trigger(errorInput);
          setTimeout(() => clearErrors(errorInput), 100);
        } else {
          setError(errorInput, {
            type: "manual",
            message: message,
          });
          e.target.value = "";
        }
      });
    } else {
      setValue(errorInput, "");
    }
  };
  const handleImageChangeHindi = (e, errorInput, url) => {
    const file = e.target.files[0];
    if (file) {
      ValidateImgWithSize(file, (isValid, message) => {
        if (isValid) {
          setValue(errorInput, file); // Set as File object, not string
          const imageUrl = URL.createObjectURL(file);
          setValue(url, imageUrl);
          trigger(errorInput);
          setTimeout(() => clearErrors(errorInput), 100);
        } else {
          setError(errorInput, {
            type: "manual",
            message: message,
          });
          e.target.value = "";
        }
      });
    } else {
      setValue(errorInput, "");
    }
  };
  const handleImageClose = () => {
    setImageOpen(!imageOpen);
  };
  const handleImageOpenPreview = (row) => {
    setImageOpen(!imageOpen);
    setValue("image_preview", row);
    trigger("image_preview");
  };
  const handleImageOpenPreviewHindi = (row) => {
    setImageOpen(!imageOpen);
    setValue("image_preview", row);
    trigger("image_preview");
  };
  const handleStatusChange = (selectedOption) => {
    setValue("status", selectedOption || "");
    trigger("status");
  };

  const confirmStatusChange = () => {
    const updatedStatus = selectedRow.status === true ? true : false;

    const formObject = {
      id: selectedRow.id,
      status: updatedStatus,
    };

    const encryptedData = encrypt(formObject);
    const encryptData = {
      zero: encryptedData,
    };
    statusUpdateBannerAPI(encryptData)
      .then((res) => {
        // decrypt data
        const status = decrypt(res.data.status);
        if (status === "success") {
          getBannerData();
          toast.success(res.data.message);
          toast.clearWaitingQueue();
        } else if (status === "failed") {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (status === "expired") {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => console.error("Error updating status:", err));

    setShowModal(false);
  };

  const handleImageChange1 = (e, imageField, imageUrlField) => {
    const file = e.target.files[0];
    if (!file) return;

    const maxSizeMB = 1;
    if (file.size > maxSizeMB * 1024 * 1024) {
      setError(imageField, {
        type: "manual",
        message: "Image must be less than 1MB",
      });
      return;
    }

    const img = new Image();
    const objectUrl = URL.createObjectURL(file);
    img.src = objectUrl;

    img.onload = () => {
      if (img.width !== 1920 || img.height !== 566) {
        setError(imageField, {
          type: "manual",
          message: "Image dimensions must be exactly 1920x566 pixels", // fixed typo
        });
        return;
      }

      // ✅ All validations passed — only now we clear errors and set values
      clearErrors(imageField);
      setValue(imageField, file);
      setValue(imageUrlField, objectUrl);
    };

    img.onerror = () => {
      setError(imageField, {
        type: "manual",
        message: "Invalid image file",
      });
    };
  };

  return (
    <>
      <Head title={"Manage Banner"} />
      <Content>
        <BlockHead size={`sm`}>
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                {"Manage Banner"}
              </BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="">
                <Button
                  color="primary"
                  outline
                  className={`  me-n1`}
                  onClick={() => {
                    setIsOpen((pre) => !pre);
                    setMode("Add");
                    reset();
                  }}
                >
                  <Icon name={isOpen ? "minus" : "plus"} />
                </Button>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block>
          <Row className={"g-gs"}>
            {isOpen && (
              <PreviewAltCard>
                <Form onSubmit={handleSubmit(onFormSubmit)}>
                  <Row>
                    {/*Image Alt */}
                    <Col md="4" sm="3" xxl="4">
                      <div className="form-group">
                        <Label className="form-label" htmlFor="image_alt">
                          {"Alt Tag"}
                          <Required />
                        </Label>
                        <div className="form-control-wrap">
                          <input
                            placeholder={"Enter Alt tag"}
                            type="text"
                            id="image_alt"
                            {...register("image_alt", {
                              required: {
                                value: true,
                                message: "Alt tag is required",
                              },
                              // pattern: {
                              //   value: /^(?!\s*$)[a-zA-Z /.]*$/,
                              //   message: "Only alphabets are allowed",
                              // },
                              minLength: {
                                value: 3,
                                message: "Alt tag must be at least 2 characters long",
                              },
                              maxLength: {
                                value: 50,
                                message: "Alt tag cannot exceed 50 characters",
                              },
                            })}
                            className="form-control"
                            value={watch("image_alt")}
                            onChange={(e) => {
                              // let value = e.target.value.replace(/[^A-Za-z\s]/g, ""); // Remove invalid characters
                              // value = value.replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
                              setValue("image_alt", e.target.value);
                              trigger("image_alt"); // Trigger validation
                            }}
                            // onInput={(e) => {
                            //   e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, "");
                            // }}
                          />
                          {errors.image_alt && <span className="invalid">{errors?.image_alt?.message}</span>}
                        </div>
                      </div>
                    </Col>{" "}
                    {/*Image Alt HN */}
                    <Col md="4" sm="3" xxl="4">
                      <div className="form-group">
                        <Label className="form-label" htmlFor="image_alt_hn">
                          {"Alt Tag Hindi"}
                          <Required />
                        </Label>
                        <div className="form-control-wrap">
                          <input
                            placeholder={"Enter Alt tag in hindi"}
                            type="text"
                            id="image_alt_hn"
                            {...register("image_alt_hn", {
                              required: {
                                value: true,
                                message: "Alt tag is required",
                              },
                              // pattern: {
                              //   value: /^(?!\s*$)[a-zA-Z /.]*$/,
                              //   message: "Only alphabets are allowed",
                              // },
                              minLength: {
                                value: 3,
                                message: "Alt tag must be at least 2 characters long",
                              },
                              maxLength: {
                                value: 50,
                                message: "Alt tag cannot exceed 50 characters",
                              },
                            })}
                            className="form-control"
                            value={watch("image_alt_hn")}
                            onChange={(e) => {
                              // let value = e.target.value.replace(/[^A-Za-z\s]/g, ""); // Remove invalid characters
                              // value = value.replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
                              setValue("image_alt_hn", e.target.value);
                              trigger("image_alt_hn"); // Trigger validation
                            }}
                            // onInput={(e) => {
                            //   e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, "");
                            // }}
                          />
                          {errors.image_alt_hn && <span className="invalid">{errors?.image_alt_hn?.message}</span>}
                        </div>
                      </div>
                    </Col>{" "}
                    {/* Banner Order */}
                    <Col md="2" sm="3" xxl="2">
                      <div className="form-group">
                        <Label className="form-label" htmlFor="order">
                          {"Order"}
                          <Required />
                        </Label>
                        <div className="form-control-wrap">
                          <input
                            placeholder={"Enter order"}
                            type="text"
                            id="order"
                            {...register("order", {
                              required: "Order is required",
                              pattern: {
                                value: /^[1-9][0-9]{0,2}$/,
                                message: "Enter a Order greater than 0 and up to 100",
                              },
                              minLength: {
                                value: 1,
                                message: "Order must be at least 1 character long",
                              },
                              validate: (value) => (value >= 1 && value <= 100) || "Order must be between 1 and 100",
                            })}
                            className="form-control"
                            onChange={(e) => {
                              e.target.value = e.target.value.replace(/[^0-9]/g, ""); // Remove non-numeric characters
                              setValue("order", e.target.value);
                              trigger("order"); // Trigger validation
                            }}
                            value={watch("order")}
                          />
                          {errors.order && <span className="invalid">{errors?.order?.message}</span>}
                        </div>
                      </div>
                    </Col>{" "}
                    <Col md={`2`}>
                      <div className="form-group">
                        <Label className="from-label" htmlFor="status">
                          Status
                        </Label>
                        <div className="form-control-wrap">
                          <Select
                            className=""
                            id="status"
                            options={[
                              { value: true, label: "Active" },
                              { value: false, label: "InActive" },
                            ]}
                            {...register("status", {
                              required: "Please select status",
                            })}
                            onChange={handleStatusChange}
                            value={watch("status")}
                          />
                          {errors.status && (
                            <span
                              className="invalid"
                              style={{
                                color: "#e85347",
                                fontSize: "11px",
                                fontStyle: "italic",
                              }}
                            >
                              {errors?.status?.message}
                            </span>
                          )}
                        </div>
                      </div>
                    </Col>
                    <ImageUpload
                      handleImageChange={handleImageChange}
                      watch={watch}
                      register={register}
                      errors={errors}
                      setValue={setValue}
                      setError={setError}
                      clearErrors={clearErrors}
                      handleImageOpenPreview={handleImageOpenPreview}
                      label="Banner Image"
                      image="banner_image"
                      image_url="banner_image_url"
                      validate={true} // Enable validation
                    />
                    <ImageUpload
                      handleImageChange={handleImageChangeHindi}
                      watch={watch}
                      register={register}
                      errors={errors}
                      setValue={setValue}
                      setError={setError}
                      clearErrors={clearErrors}
                      handleImageOpenPreview={handleImageOpenPreviewHindi}
                      label="Banner Image Hindi"
                      image="banner_image_hn"
                      image_url="banner_image_url_hn"
                      validate={true} // Enable validation
                    />
                  </Row>
                  <Col md="2" className={``}>
                    <div className="form-group" style={{ marginTop: "31px" }}>
                      <Button disabled={isLoading} color="primary" size="md">
                        {isLoading ? <Spinner size="sm" color="primary" /> : mode == "Add" ? "Save" : "Update"}
                      </Button>
                    </div>
                  </Col>
                </Form>
              </PreviewAltCard>
            )}
          </Row>

          <MyDataTable data={data} columns={column} title={"Banner"} isLoading={isLoading} />
        </Block>

        <ViewImage url={watch("image_preview")} imageOpen={imageOpen} handleImageClose={handleImageClose} />
        {/* Confirmation Modal */}
        <ConfirmModal
          isOpen={showModal}
          toggle={() => setShowModal(!showModal)}
          onConfirm={confirmStatusChange}
          status={selectedRow?.status}
        />
      </Content>
    </>
  );
};

export default Banner;
